import React from 'react';
import cn from 'classnames';
import styles from './display-image.module.css';

interface DisplayImageProps {
  src: string;
}

export const DisplayImage: React.FC<DisplayImageProps> = ({ src }) => (
  <img className={cn(styles.image)} src={src} alt="Display" />
);